import { Component, OnInit, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FormControlEx } from '../../../core/component/forms/form-control';
import { OrganizationOfTenantsKindToString, OrganizationOfTenantsKind } from '../../model/const/enums';
import { DwellingContract } from '../../model/dwelling-contract';
import { Property } from '../../model/property';

@Component({
    selector: 'app-negotiation',
    templateUrl: './negotiation.component.html',
    styleUrls: ['./negotiation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NegotiationComponent implements OnInit {
  constructor(private _fc: FormControlExFactory) {}

  @Input() form: FormGroup;
  @Input() dataContext: DwellingContract | Property;

  itemsSource: { name: string; value: any }[];
  get negotiatingClause(): FormControlEx {
    return this.form.controls['negotiatingClause'] as FormControlEx;
  }
  get organizationOfTenants(): FormControlEx {
    return this.form.controls['organizationOfTenants'] as FormControlEx;
  }
  get otherOrganizationOfTenants(): FormControlEx {
    return this.form.controls['otherOrganizationOfTenants'] as FormControlEx;
  }

  ngOnInit() {
    this.form.addControl(
      'negotiatingClause',
      this._fc.create('NEGOTIATION_FORM.NEGOTIATION_CLAUSE_LABEL', this.dataContext.negotiatingClause)
    );
    this.form.addControl(
      'organizationOfTenants',
      this._fc.create('NEGOTIATION_FORM.ORGANIZATION_OF_TENANTS_LABEL', this.dataContext.organizationOfTenants)
    );
    this.form.addControl(
      'otherOrganizationOfTenants',
      this._fc.createMaxLength('NEGOTIATION_FORM.OTHER_ORGANIZATION_OF_TENANTS_LABEL', this.dataContext.otherOrganizationOfTenants, 50)
    );

    this.organizationOfTenants.isReadonly = !this.dataContext.negotiatingClause;
    this.negotiatingClause.valueChanges.subscribe(value => {
      if (!value) {
        this.organizationOfTenants.setValue(OrganizationOfTenantsKind.None);
        this.otherOrganizationOfTenants.reset();
      }
      this.organizationOfTenants.isReadonly = !value;
    });

    this.organizationOfTenants.valueChanges.subscribe(value => {
      this.otherOrganizationOfTenants.required = value === OrganizationOfTenantsKind.OtherAssociation;
    });

    this.itemsSource = [
      { name: OrganizationOfTenantsKindToString(OrganizationOfTenantsKind.None), value: OrganizationOfTenantsKind.None },
      {
        name: OrganizationOfTenantsKindToString(OrganizationOfTenantsKind.TenantsAssociation),
        value: OrganizationOfTenantsKind.TenantsAssociation,
      },
      {
        name: OrganizationOfTenantsKindToString(OrganizationOfTenantsKind.OtherAssociation),
        value: OrganizationOfTenantsKind.OtherAssociation,
      },
    ];
  }
}
